module.exports = __webpack_public_path__ + "d8d25a163693fbe7a28113af75ba45ee.MP3";